module.exports = __webpack_public_path__ + "img/aftersell-en.da0107e3.png";